import * as React from 'react';
import VoxelText, { VoxelTextProps } from '../../Text/VoxelText';

export interface SearchInfoToolipProps extends Omit<VoxelTextProps, 'children' | 'classname'> { }

const SearchInfoTooltipContent = React.forwardRef<HTMLParagraphElement, SearchInfoToolipProps>(
  (props, ref) => {
    return (
      <VoxelText div className="w-64 !text-[13px]" ref={ref} {...props}>
        Enter list of seeds separated by comma or line break. Pasted tab values will be replaced
        with line breaks.
        <br></br>
        <br></br>
        <span className='font-medium'>Valid characters</span>
        <br></br>
        Unicode letters, unicode numbers, full stop (.), space ( ), apostrophe ('), quotation mark
        ("), ampersand (&), hyphen minus (-).
        <br></br>
      </VoxelText>
    );
  }
);

export default SearchInfoTooltipContent;
